import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { ruleFieldFromDto, ruleGroupCreateToDto, ruleGroupFromDto, ruleGroupUpdateToDto } from '@/features/agreements/mappers/ruleGroupsMapper';
import { validateRequiredFields } from '@/shared/utils/validateRequiredFields';

const BASE_ENDPOINT = 'rule-groups';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
};

export const getRuleGroups = async (data = {}) => {
  const params = {
    agreement: data.agreementId,
    agreement_plan: data.agreementPlanId,
    rate: data.rateId
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint, { params });
  return response.data.map(ruleGroupFromDto);
};

/** Obtiene los campos de reglas disponibles para configurar RuleGroup */
export const getRuleFields = async () => {
  const endpoint = buildServiceEndpoint({ action: 'rule-fields' });
  const response = await api.get(endpoint);
  return response.data.map(ruleFieldFromDto);
};

export const createRuleGroup = async (data) => {
  const payload = ruleGroupCreateToDto(data);
  const endpoint = buildServiceEndpoint();
  const response = await api.post(endpoint, payload);
  return ruleGroupFromDto(response.data);
};

export const updateRuleGroup = async (id, data) => {
  validateRequiredFields({ id });

  const payload = ruleGroupUpdateToDto(data);
  const endpoint = buildServiceEndpoint({ id });
  const response = await api.put(endpoint, payload);
  return ruleGroupFromDto(response.data);
};

/** El endpoint responde con un código 204 (No Content), por lo que no se retorna ningún valor. */
export const deleteRuleGroup = async (id) => {
  validateRequiredFields({ id });

  const endpoint = buildServiceEndpoint({ id });
  await api.delete(endpoint);
};

export const restoreRuleGroup = async (id) => {
  validateRequiredFields({ id });

  const endpoint = buildServiceEndpoint({ id, action: 'restore' });
  const response = await api.post(endpoint);
  return ruleGroupFromDto(response.data);
};